import { Injectable, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { select, Store } from '@ngrx/store';
import { Observable, combineLatest } from 'rxjs';
import { take } from 'rxjs/operators';
import * as AnnotationsActions from '../actions/annotations.actions';
import * as AnnotationsReducer from '../reducers/annotations.reducer';
import * as AnnotationsSelectors from '../selectors/annotations.selectors';

@Injectable()
export class AnnotationsStoreFacade {
  private store = inject(Store<AnnotationsReducer.State>);

  annotations$ = this.store.pipe(select(AnnotationsSelectors.selectAnnotations));
  loading$ = this.store.pipe(select(AnnotationsSelectors.selectIsLoading));
  loaded$ = this.store.pipe(select(AnnotationsSelectors.selectIsLoaded));

  annotations = toSignal(this.annotations$, {
    initialValue: {} as { [category: string]: { [id: string]: any } },
  });

  loaded = toSignal(this.loaded$, { initialValue: false });

  getAnnotation$(category: string, id: string): Observable<any> {
    this.ensureLoaded();
    return this.store.pipe(
      select(AnnotationsSelectors.selectAnnotation(category, id))
    );
  }

  getAnnotation(
    annotationRef: { category?: string | null; id?: string | null } | null | undefined
  ): any {
    if (!annotationRef?.category || !annotationRef?.id) return null;
    return this.annotations()?.[annotationRef.category]?.[annotationRef.id] ?? null;
  }

  ensureLoaded(): void {
    combineLatest([
      this.store.pipe(select(AnnotationsSelectors.selectIsLoaded)),
      this.store.pipe(select(AnnotationsSelectors.selectIsLoading)),
    ])
      .pipe(take(1))
      .subscribe(([loaded, loading]) => {
        if (!loaded && !loading) {
          this.store.dispatch(AnnotationsActions.loadAnnotations());
        }
      });
  }
}
